import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";

import {
  Modal,
  Button,
  Row,
  Col,
  Alert,
  FormLabel,
  Form as FormBoostrap,
} from "react-bootstrap";
import FormSelect from "../../global/form/FormSelect";
import { DatePicker } from "../../global/form/DatePicker";
import { registerLocale } from "react-datepicker";
import es from "date-fns/locale/es";
import TextLoading from "../../global/TextLoading";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import AsyncSelect from "react-select/async";
import { GetUserForNotifications, CreateNotification } from "../../../api/News";
const prefix = process.env.REACT_APP_PREFIX;

const templateLevel = {
  level: "",
  grade: "",
  group: "",
  gradeList: [],
  groupList: [],
  program: "",
  programLevel: "",
  programLevelList: [],
  programs: [],
};

const customStyles = {
  levelsLabel: {
    color: "#888",
    fontSize: "12px",
    fontStyle: "italic",
    opacity: "0.7",
  },
};

export default function ModalSendNotification(props) {
  const [t] = useTranslation(["global", "modalNotifications"]);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState(false);
  const [targetRecipient, setTargetRecipient] = useState({});
  let [typingCallback, setTypingCallback] = useState(null);
  const [cycleSelected, setCycleSelected] = useState(null);
  const [targetDefaultItems, setTargetDefaultItems] = useState([]);
  const [loadingDefaultItems, setLoadingDefaultItems] = useState(false);
  const [gradesGroupLevels, setGradesGroupLevels] = useState([
    { ...templateLevel },
  ]);

  const [cycles, setCycles] = useState([]);
  const [levels, setLevels] = useState([]);
  const [showModal, setShowModal] = useState(props.showModalSendNotification);
  const [userIsMulti, setUserIsMulti] = useState(true);
  const notification = {
    title: props.news.title || "",
    text: props.news.content || "",
    type: "blog",
    blog_id: props.news.id,
    school_cycle_id: "",
    recipients: "all",
    programs_ids: [],
    levels: [{ ...templateLevel }],
    //schedule
    date: "",
    time: "",
  };
  const [notificationData, setNotificationData] = useState(notification);
  const [programs, setPrograms] = useState([]);

  // Modal schedule
  const language = t("modalCreateStudent:language");

  //Traslate calendar
  registerLocale("spanish", es);
  let Locallanguage = {};
  if (language === "spanish") {
    Locallanguage = { locale: "spanish" };
  }
  const [showScheduleModal, setShowScheduleModal] = useState(false);

  const optionsSendTo = [
    { value: "all", label: t("news:modalNotifications.all") },
    { value: "level", label: t("news:modalNotifications.level") },
    { value: "teacher", label: t("news:modalNotifications.teachers") },
    {
      value: "parent",
      label: t("news:modalNotifications.relatives"),
    },
    { value: "student", label: t("news:modalNotifications.students") },
    {
      value: "academicOffer",
      label: t("news:modalNotifications.academicOffert"),
    },
  ];

  const getOptionsSendTo = () => {
    // Ejemplo: ocultar "student" y "level" si el ciclo no tiene niveles
    if (
      cycleSelected &&
      (!cycleSelected.schoolLevels || cycleSelected.schoolLevels.length === 0)
    ) {
      const ocultar = ["level"];
      return optionsSendTo.filter((option) => !ocultar.includes(option.value));
    }
    if (cycleSelected && programs.length === 0) {
      const ocultar = ["student"];
      return optionsSendTo.filter((option) => !ocultar.includes(option.value));
    }
    return optionsSendTo;
  };

  const recipientOptions = {
    teacher: {
      label: t("news:modalNotifications.selectTeacher"),
      placeholder: t("news:modalNotifications.selectTeacher"),
      value: "teacher",
    },
    student: {
      label: t("news:modalNotifications.selectStudent"),
      placeholder: t("news:modalNotifications.selectStudent"),
      value: "student",
    },
    parent: {
      label: t("news:modalNotifications.selectRelative"),
      placeholder: t("news:modalNotifications.selectRelative"),
      value: "parent",
    },
    academicOffer: {
      label: t("news:modalNotifications.selectAcademicOffert"),
      placeholder: t("news:modalNotifications.selectAcademicOffert"),
      value: "academicOffer",
    },
    all: {
      label: t("news:modalNotifications.all"),
      placeholder: t("news:modalNotifications.all"),
      value: "all",
    },
    level: {
      label: t("news:modalNotifications.level"),
      placeholder: t("news:modalNotifications.level"),
      value: "level",
    },
  };

  useEffect(() => {
    // obtener ciclos del local storage
    let storedCycles =
      JSON.parse(localStorage.getItem(`cycles${prefix}`)) || [];

    const cyclesFormatted = [];
    if (storedCycles.length > 0) {
      for (let cycle of storedCycles) {
        // Unir los nombres de los niveles
        const levelsText = cycle.school_levels
          .map((level) => level.school_level_name)
          .join(", ");
        cyclesFormatted.push({
          label: (
            <span>
              {cycle.school_cycle}
              <br />
              <span style={customStyles.levelsLabel}>{levelsText}</span>
            </span>
          ),
          value: cycle.id,
          schoolLevels: cycle.school_levels.map((level) => ({
            label: level.school_level_name,
            value: level.id,
            grades: level.grades.map((grade) => ({
              label: grade.grade_level,
              value: grade.id,
              groups: grade.groups.map((group) => ({
                label: group.name,
                value: group.grade_group_grade_level_id,
              })),
            })),
          })),
        });
      }
    }
    setCycles(cyclesFormatted);
  }, []);

  const obtainProgramsByCycle = (cycleId, levelsWithGrades) => {
    let storedCycles =
      JSON.parse(localStorage.getItem(`cycles${prefix}`)) || [];
    let programs = [];
    if (storedCycles.length > 0) {
      let cycle = storedCycles.find((c) => c.id === cycleId);
      if (cycle) {
        let colleges_and_schools = cycle.colleges_and_schools;
        for (let single_colleges of colleges_and_schools) {
          let colleges_levels = single_colleges.school_levels;
          for (let single_level of colleges_levels) {
            let level_programs = single_level.programs;
            for (let single_program of level_programs) {
              if (single_program.enabled == 1) {
                let program = {};
                program.name = single_program.name;
                program.level_name =
                  " (" + single_level.school_level_name + ")";
                program.program_id = single_program.id;
                program.enabled = single_program.enabled;
                program.program_levels = single_program.program_levels;
                program.value = single_program.id;
                program.label = single_program.name;
                programs.push(program);
              }
            }
          }
        }
      }
    }
    setPrograms(programs);
    if (programs.length > 0) {
      //agregar al final de levels la opcion  educacion superior
      const levelsUpdated = [...levelsWithGrades];
      levelsUpdated.push({
        label: t("news:modalNotifications.higherEducation"),
        value: "higherEducation",
      });
      setLevels(levelsUpdated);
    }
  };

  // Validacion YUP
  const validateSchema = Yup.object().shape({
    school_cycle_id: Yup.string().required(
      t("news:modalNotifications.schoolCycle") +
        " " +
        t("modalCreateStudent:labels.isRequired")
    ),
    recipients: Yup.string().required(
      t("news:modalNotifications.sendTo") +
        " " +
        t("modalCreateStudent:labels.isRequired")
    ),
    users: Yup.mixed().when("recipients", {
      is: (recipients) =>
        ["teacher", "parent", "student", "academicOffer"].includes(recipients),
      then: Yup.mixed()
        .test(
          "users-array-or-object",
          t("news:modalNotifications.selectAtLeastOneItem"),
          function (value) {
            // Si es array, debe tener al menos un elemento
            if (Array.isArray(value)) {
              return value.length > 0;
            }
            // Si es objeto, debe tener al menos una propiedad
            if (typeof value === "object" && value !== null) {
              return Object.keys(value).length > 0;
            }
            // Si es null o undefined, no es válido
            return false;
          }
        )
        .required(t("news:modalNotifications.selectAtLeastOneItem")),
      otherwise: Yup.mixed().notRequired(),
    }),
    levels: Yup.array().when("recipients", {
      is: "level",
      then: Yup.array()
        .of(
          Yup.object().shape({
            level: Yup.string().required(
              t("news:modalNotifications.schooling") +
                " " +
                t("modalCreateStudent:labels.isRequired")
            ),
            // grade es requerido solo si el nivel no es educacion superior
            grade: Yup.string().when("level", {
              is: (level) => level !== "higherEducation",
              then: Yup.string().required(
                t("news:modalNotifications.grade") +
                  " " +
                  t("modalCreateStudent:labels.isRequired")
              ),
              otherwise: Yup.string().notRequired(),
            }),
            // group es requerido solo si el nivel no es educacion superior y grade no es all
            group: Yup.string().when("grade", {
              is: (grade) => grade && grade !== "all" && grade !== "",
              then: Yup.string().required(
                t("news:modalNotifications.group") +
                  " " +
                  t("modalCreateStudent:labels.isRequired")
              ),
              otherwise: Yup.string().notRequired(),
            }),

            // program es requerido solo si el nivel es educacion superior
            program: Yup.string().when("level", {
              is: "higherEducation",
              then: Yup.string().required(
                t("news:modalNotifications.academicOffert") +
                  " " +
                  t("modalCreateStudent:labels.isRequired")
              ),
              otherwise: Yup.string().notRequired(),
            }),
            // programLevel es requerido solo si el nivel es educacion superior y program no es all
            programLevel: Yup.string().when("program", {
              is: (program) => program && program !== "all" && program !== "",
              then: Yup.string().required(
                t("news:modalNotifications.level") +
                  " " +
                  t("modalCreateStudent:labels.isRequired")
              ),
              otherwise: Yup.string().notRequired(),
            }),
          })
        )
        .min(1, t("news:modalNotifications.selectAtLeastOneItem"))
        .required(t("news:modalNotifications.selectAtLeastOneItem")),
      otherwise: Yup.array().notRequired(),
    }),
  });

  const validationScheduleSchema = Yup.object().shape({
    date: Yup.string().required(
      t("news:modalSchedule.date") +
        " " +
        t("modalCreateStudent:labels.isRequired")
    ),
    time: Yup.string().required(
      t("news:modalSchedule.time") +
        " " +
        t("modalCreateStudent:labels.isRequired")
    ),
  });

  const createNotification = (values) => {
    let payload = {
      device: "all",
      event_id: "1",
      title: values.title || "",
      text: values.text.replace(/<[^>]+>/g, "") || values.title || "",
      type: values.type,
      blog_id: values.blog_id,
      type_user: values.recipients,
      school_cycle_id: values.school_cycle_id,
    };
    if (
      values.levels &&
      values.levels.length > 0 &&
      (values.levels[0].grade != "" || values.levels[0].program != "")
    ) {
      payload.type_user = "student";
      for (const iteRow of values.levels) {
        if (iteRow.group != "") {
          if (payload.grade_group_grade_levels) {
            payload.grade_group_grade_levels.push(iteRow.group);
          } else {
            payload.grade_group_grade_levels = [iteRow.group];
          }
        }
        if (iteRow.grade == "all") {
          if (payload.organization_school_level_cycle_ids) {
            payload.organization_school_level_cycle_ids.push(iteRow.group);
          } else {
            payload.organization_school_level_cycle_ids = [iteRow.level];
          }
        }
        if (iteRow.level == "higherEducation" && iteRow.programLevel != "") {
          if (payload.program_level_cycle_id) {
            payload.program_level_cycle_id.push(iteRow.programLevel);
          } else {
            payload.program_level_cycle_id = [iteRow.programLevel];
          }
        }
      }
    }
    if (values.recipients == "academicOffer") {
      payload.programs_ids = [];
      payload.type_user = "student";
      if (values.users && values.users.length > 0) {
        payload.programs_ids.push(values.users[0].value);
      }
    }
    if (
      values.users &&
      values.users.length > 0 &&
      values.recipients != "academicOffer"
    ) {
      if (values.users[0].value === "all") {
        const usersGroups = {
          teacher: 7,
          parent: 6,
          student: 8,
        };
        payload.users_group_id = usersGroups[targetRecipient.value] || 0;
      } else {
        payload.users = values.users.map((user) => user.value);
      }
    }

    if (values.date && values.time && showScheduleModal) {
      // Combinar fecha y hora en un solo objeto Date
      const dateObj = new Date(values.date);
      const timeObj = new Date(values.time);

      dateObj.setHours(timeObj.getHours());
      dateObj.setMinutes(timeObj.getMinutes());
      dateObj.setSeconds(timeObj.getSeconds());
      dateObj.setMilliseconds(timeObj.getMilliseconds());

      payload.send_date = values.date
        ? Math.floor(dateObj.getTime() / 1000)
        : "";
    }
    if (payload.type_user === "all") {
      payload.general_with_cycle = "1";
    }
    CreateNotification(payload)
      .then((response) => {
        if (response.status != 200) {
          setError(response.error.description);
        } else {
          const message = {
            title: t("news:modalConfirm.newsCreated"),
            message: t(
              showScheduleModal
                ? "news:modalNotifications.notificationSuccessSheduleMenssage"
                : "news:modalNotifications.notificationSuccessMenssage"
            ),
          };
          props.notificationCreated(message);
        }
      })
      .finally(() => {
        setSaving(false);
      });
  };

  const searchUsers = (inputValue, callback, recipient = targetRecipient) => {
    setLoadingDefaultItems(true);
    let payload = {
      school_cycle_id: cycleSelected ? cycleSelected.value : "",
      search: inputValue || "",
    };
    if (recipient.value === "academicOffer") {
      payload.program_id = 0;
    }
    if (recipient.value === "teacher") {
      payload.group_id = 7;
    }
    if (recipient.value === "student") {
      payload.group_id = 8;
      payload.only_higher_level = 1;
    }
    if (recipient.value === "parent") {
      payload.group_id = 6;
      payload.only_basic_levels = 1;
    }
    if (typingCallback) {
      clearTimeout(typingCallback);
    }
    typingCallback = setTimeout(() => {
      GetUserForNotifications(payload).then((result) => {
        let itemList = [];
        if (recipient.value === "academicOffer") {
          itemList = result.data.map((item) => {
            return {
              label: `${item.name}  (${item.school_level.name})`,
              value: item.id,
            };
          });
        } else if (recipient.value === "teacher") {
          itemList = result.data.map((item) => {
            return {
              label: `${item.last_name}, ${item.first_name}  ${
                item.middle_name || ""
              } `,
              value: item.id || item.student_id,
            };
          });
          //agregar al inicio la opcion de todos
          itemList.unshift({
            label: t("news:modalNotifications.all"),
            value: "all",
          });
        } else if (recipient.value === "parent") {
          itemList = result.data.map((item) => {
            return {
              label: `${item.relationship_student} ${
                language === "spanish" ? " de " : " of "
              } ${item.student_last_name}, ${item.student_name}`,
              value: item.id || item.student_id,
            };
          });
          //agregar al inicio la opcion de todos
          itemList.unshift({
            label: t("news:modalNotifications.all"),
            value: "all",
          });
        } else {
          itemList = result.data.map((item) => {
            return {
              label: `${item.last_name}, ${item.first_name || ""} ${
                item.school_level
              }`,
              value: item.id_user,
            };
          });
          itemList.unshift({
            label: t("news:modalNotifications.all"),
            value: "all",
          });
        }
        setTargetDefaultItems(itemList);
        setLoadingDefaultItems(false);
        if (!callback) return;
        callback(itemList);
      });
    }, 1000);
    setTypingCallback(typingCallback);
  };

  const validateErrorLevelGradeGroup = (formik, imputName, index) => {
    return (
      Array.isArray(formik.touched?.levels) &&
      Array.isArray(formik.errors?.levels) &&
      formik.touched.levels[index] &&
      formik.errors.levels[index]?.[imputName] && (
        <FormBoostrap.Text className="text-muted error">
          {formik.errors.levels[index][imputName]}
        </FormBoostrap.Text>
      )
    );
  };

  const getMinTime = (selectedDate) => {
    const today = new Date();
    if (
      selectedDate &&
      today.toDateString() === new Date(selectedDate).toDateString()
    ) {
      return today;
    }
    // Si no es hoy, la hora mínima es 00:00
    const min = new Date();
    min.setHours(0, 0, 0, 0);
    return min;
  };

  return (
    <>
      <Modal
        show={showModal}
        size={targetRecipient?.value == "level" ? "lg" : "md"}
        aria-labelledby="contained-modal-title-lg"
      >
        <Modal.Header className="pb-0">
          <Modal.Title className="modal-title">
            {t("news:modalNotifications.sendNotification")}
          </Modal.Title>
        </Modal.Header>

        <Formik
          context={{ showScheduleModal }}
          initialValues={notificationData}
          validationSchema={validateSchema}
          validateOnChange={true}
          validateOnBlur={true}
          onSubmit={async (values) => {
            setSaving(true);
            createNotification(values);
          }}
        >
          {(formik) => (
            <Form>
              <Modal.Body>
                <Alert variant="success">
                  {t("news:modalNotifications.itemCreatedMsg1")}
                  <br />
                  {t("news:modalNotifications.itemCreatedMsg2")}
                </Alert>
                <Row className="mb-2">
                  <Col md={12}>
                    <h6>{t("news:modalNotifications.selectCycleMenssage")}</h6>
                  </Col>
                </Row>
                {/* cycle */}
                <Row>
                  <Col md={12}>
                    <FormSelect
                      filterOption={(option, inputValue) => {
                        const label =
                          option.label.props.children[0].toLowerCase();
                        return label.includes(inputValue.toLowerCase());
                      }}
                      label={t("news:modalNotifications.schoolCycle")}
                      name="school_cycle_id"
                      options={cycles}
                      onChange={(event) => {
                        formik.setFieldValue("school_cycle_id", event.value);
                        const levelsWithGrades = event.schoolLevels.filter(
                          (level) => level.grades.length > 0
                        );
                        setLevels(levelsWithGrades);
                        setCycleSelected(event);
                        formik.setFieldValue("users", []);
                        formik.setFieldValue("recipients", "all");
                        setTargetRecipient(null);
                        obtainProgramsByCycle(event.value, levelsWithGrades);
                      }}
                      value={
                        cycles.find(
                          (cycle) =>
                            cycle.value === formik.values.school_cycle_id
                        ) || null
                      }
                      showRequired={true}
                      placeholder={t(
                        "news:modalNotifications.schoolCyclePlaceholder"
                      )}
                    />
                  </Col>
                </Row>
                {/* Send To */}
                <Row>
                  <Col md={12}>
                    <FormSelect
                      label={t("news:modalNotifications.sendTo")}
                      name="recipients"
                      options={getOptionsSendTo()}
                      onChange={(event) => {
                        formik.setFieldValue("users", []);
                        setTargetDefaultItems(null);
                        setTargetRecipient(recipientOptions[event.value]);
                        formik.setFieldValue("recipients", event.value);
                        if (
                          [
                            "teacher",
                            "parent",
                            "student",
                            "academicOffer",
                          ].includes(event.value)
                        ) {
                          searchUsers("", null, recipientOptions[event.value]);
                        }
                        if (event.value != "level") {
                          setGradesGroupLevels([{ ...templateLevel }]);
                          // setGrades([]);
                          // setGroups([]);
                          formik.setFieldValue("levels", [
                            { ...templateLevel },
                          ]);
                        }
                      }}
                      value={
                        optionsSendTo.find(
                          (option) => option.value === formik.values.recipients
                        ) || null
                      }
                      showRequired={true}
                      placeholder={t("news:modalNotifications.sendTo")}
                      isDisabled={!formik.values.school_cycle_id}
                    />
                  </Col>
                </Row>
                {["teacher", "parent", "student", "academicOffer"].includes(
                  formik.values.recipients
                ) && (
                  <Row>
                    <Col md={12}>
                      <FormLabel>{targetRecipient.label || ""}</FormLabel>
                      <AsyncSelect
                        name="users"
                        // solo es multiple cuando no se selecciona la opcion all
                        isMulti={userIsMulti}
                        loadOptions={searchUsers}
                        defaultOptions={targetDefaultItems}
                        placeholder={targetRecipient.placeholder}
                        onChange={(selected) => {
                          if (
                            Array.isArray(selected) &&
                            selected.some((item) => item.value === "all")
                          ) {
                            formik.setFieldValue("users", [
                              {
                                label: t("news:modalNotifications.all"),
                                value: "all",
                              },
                            ]);
                            setUserIsMulti(false);
                          } else {
                            setUserIsMulti(true);
                            formik.setFieldValue("users", selected);
                          }
                        }}
                        value={formik.values.users || []}
                        isClearable
                        isLoading={loadingDefaultItems}
                        isDisabled={!formik.values.school_cycle_id}
                      />
                      {formik.touched.users && formik.errors.users && (
                        <FormBoostrap.Text className="text-muted error">
                          {formik.errors.users}
                        </FormBoostrap.Text>
                      )}
                    </Col>
                  </Row>
                )}
                {formik.values.recipients === "level" &&
                  formik.values.levels.map((level, index) => (
                    <Row key={index}>
                      <Col md={4} className="mb-3">
                        <FormSelect
                          label={t("news:modalNotifications.schooling")}
                          name="level"
                          options={levels}
                          onChange={(event) => {
                            gradesGroupLevels[index].level = event.value;
                            gradesGroupLevels[index].grade = "";
                            gradesGroupLevels[index].group = "";
                            gradesGroupLevels[index].program = "";
                            gradesGroupLevels[index].programLevel = "";
                            gradesGroupLevels[index].programLevelList = [];
                            gradesGroupLevels[index].groupList = [];
                            gradesGroupLevels[index].programs = [];

                            if (event.value === "higherEducation") {
                              gradesGroupLevels[index].programs = programs;
                              // if (programs.length > 0) {
                              //   gradesGroupLevels[index].programs.unshift({
                              //     label: t("news:modalNotifications.all"),
                              //     value: "all",
                              //     program_levels: [],
                              //   });
                              // }
                            } else {
                              gradesGroupLevels[index].gradeList = event.grades;
                              // agregar la opcion todos al incio de grade list si no existe
                              if (
                                event.grades.length > 0 &&
                                !event.grades.some((g) => g.value === "all")
                              ) {
                                gradesGroupLevels[index].gradeList.unshift({
                                  label: t("news:modalNotifications.all"),
                                  value: "all",
                                  groups: [],
                                });
                              }
                            }

                            // Actualizar el estado
                            setGradesGroupLevels(gradesGroupLevels);
                            formik.setFieldValue("levels", gradesGroupLevels);
                          }}
                          value={
                            levels.find((l) => l.value === level.level) || ""
                          }
                          showRequired={true}
                          placeholder={t(
                            "news:modalNotifications.schoolingPlaceholder"
                          )}
                          className="mb-0"
                        />

                        {validateErrorLevelGradeGroup(formik, "level", index)}
                      </Col>
                      {level.level == "higherEducation" ? (
                        <>
                          <Col md={4} className="mb-3">
                            <FormSelect
                              label={t(
                                "news:modalNotifications.academicOffert"
                              )}
                              name="program"
                              options={level.programs}
                              onChange={(event) => {
                                gradesGroupLevels[index].program = event.value;
                                gradesGroupLevels[index].programLevel = "";

                                gradesGroupLevels[index].programLevelList =
                                  event.program_levels.map((pl) => ({
                                    label: pl.level,
                                    value: pl.id,
                                  })) || [];
                                setGradesGroupLevels(gradesGroupLevels);
                                formik.setFieldValue(
                                  "levels",
                                  gradesGroupLevels
                                );
                              }}
                              value={
                                level.programs.find(
                                  (g) => g.value === level.program
                                ) || ""
                              }
                              showRequired={true}
                              placeholder={
                                level.programs.length === 0
                                  ? t(
                                      "news:modalNotifications.selectAnAcademicProgram"
                                    )
                                  : t(
                                      "news:modalNotifications.selectAnAcademicProgram"
                                    )
                              }
                              isDisabled={level.programs.length === 0}
                              className="mb-0"
                            />
                            {validateErrorLevelGradeGroup(
                              formik,
                              "program",
                              index
                            )}
                          </Col>

                          <Col md={4} className="mb-3">
                            <FormSelect
                              label={t("news:modalNotifications.level")}
                              name="programLevel"
                              options={level.programLevelList}
                              onChange={(event) => {
                                gradesGroupLevels[index].programLevel =
                                  event.value;
                                setGradesGroupLevels(gradesGroupLevels);
                                formik.setFieldValue(
                                  "levels",
                                  gradesGroupLevels
                                );
                              }}
                              value={
                                level.programLevelList.find(
                                  (g) => g.value === level.programLevel
                                ) || ""
                              }
                              showRequired={true}
                              placeholder={
                                level.programLevelList.length === 0
                                  ? t("news:modalNotifications.selectLevel")
                                  : t("news:modalNotifications.selectLevel")
                              }
                              isDisabled={level.programLevelList.length === 0}
                              className="mb-0"
                            />
                            {validateErrorLevelGradeGroup(
                              formik,
                              "programLevel",
                              index
                            )}
                          </Col>
                        </>
                      ) : (
                        <>
                          <Col md={4} className="mb-3">
                            <FormSelect
                              label={t("news:modalNotifications.grade")}
                              name="grade"
                              options={level.gradeList}
                              onChange={(event) => {
                                gradesGroupLevels[index].grade = event.value;
                                gradesGroupLevels[index].group = "";
                                gradesGroupLevels[index].groupList =
                                  event.groups || [];
                                setGradesGroupLevels(gradesGroupLevels);
                                formik.setFieldValue(
                                  "levels",
                                  gradesGroupLevels
                                );
                                // setGroups(event.groups);
                              }}
                              value={
                                level.gradeList.find(
                                  (g) => g.value === level.grade
                                ) || ""
                              }
                              showRequired={true}
                              placeholder={
                                level.gradeList.length === 0
                                  ? t("news:modalNotifications.noGrade")
                                  : t(
                                      "news:modalNotifications.gradePlaceholder"
                                    )
                              }
                              isDisabled={level.gradeList.length === 0}
                              className="mb-0"
                            />
                            {validateErrorLevelGradeGroup(
                              formik,
                              "grade",
                              index
                            )}
                          </Col>
                          <Col md={4} className="mb-3">
                            <FormSelect
                              label={t("news:modalNotifications.group")}
                              name="group"
                              options={level.groupList}
                              onChange={(event) => {
                                gradesGroupLevels[index].group = event.value;
                                setGradesGroupLevels(gradesGroupLevels);
                                formik.setFieldValue(
                                  "levels",
                                  gradesGroupLevels
                                );
                              }}
                              value={
                                level.groupList.find(
                                  (g) => g.value === level.group
                                ) || ""
                              }
                              showRequired={true}
                              placeholder={
                                level.groupList.length === 0
                                  ? t("news:modalNotifications.noGroup")
                                  : t(
                                      "news:modalNotifications.groupPlaceholder"
                                    )
                              }
                              isDisabled={level.groupList.length === 0}
                              className="mb-0"
                            />
                            {validateErrorLevelGradeGroup(
                              formik,
                              "group",
                              index
                            )}
                          </Col>
                        </>
                      )}
                    </Row>
                  ))}
                {formik.values.recipients === "level" && (
                  <Row>
                    <Col md={6}>
                      <h6
                        style={{
                          fontWeight: "bold",
                          color: "rgb(118, 118, 118)",
                          fontSize: "13px",
                          cursor: "pointer",
                          width: "fit-content",
                        }}
                        className="float-start"
                        onClick={() => {
                          gradesGroupLevels.push({ ...templateLevel });
                          setGradesGroupLevels(gradesGroupLevels);
                          formik.setFieldValue("levels", gradesGroupLevels);
                        }}
                      >
                        {t("global:buttons.add")}
                        <i
                          value="add"
                          className="bi bi-plus-circle-fill"
                          style={{
                            cursor: "pointer",
                            color: "#247048",
                            fontSize: "18px",
                            marginLeft: "7px",
                            verticalAlign: "middle",
                          }}
                        />
                      </h6>
                    </Col>

                    {formik.values.levels.length > 1 && (
                      <Col md={6}>
                        <h6
                          style={{
                            fontWeight: "bold",
                            color: "rgb(118, 118, 118)",
                            fontSize: "13px",
                            cursor: "pointer",
                            width: "fit-content",
                          }}
                          className="float-end"
                          onClick={() => {
                            if (gradesGroupLevels.length > 1) {
                              gradesGroupLevels.pop();
                              setGradesGroupLevels(gradesGroupLevels);
                              formik.setFieldValue("levels", gradesGroupLevels);
                            }
                          }}
                        >
                          {t("global:buttons.eliminate")}
                          <i
                            value="delete"
                            className="bi bi-x-circle-fill"
                            style={{
                              cursor: "pointer",
                              color: "#ea2c54",
                              fontSize: "18px",
                              marginLeft: "7px",
                              verticalAlign: "middle",
                            }}
                          />
                        </h6>
                      </Col>
                    )}
                  </Row>
                )}
                {error && (
                  <Row className="mt-3">
                    <Col md={12}>
                      <Alert
                        variant="warning"
                        style={{ wordBreak: "break-word" }}
                      >
                        {error}
                      </Alert>
                    </Col>
                  </Row>
                )}
              </Modal.Body>
              <Modal.Footer style={{ justifyContent: "space-between" }}>
                <Button
                  variant="outline-secondary"
                  onClick={() => props.setShowModalSendNotification(false)}
                  disabled={saving}
                  className="float-start"
                >
                  {t("global:buttons.cancel")}
                </Button>
                <div className="float-end">
                  <Button
                    variant="outline-secondary"
                    onClick={() => {
                      setNotificationData(formik.values);

                      formik.validateForm().then((errors) => {
                        if (Object.keys(errors).length === 0) {
                          setShowScheduleModal(true);
                          setShowModal(false);
                        } else {
                          formik.setTouched({
                            school_cycle_id: true,
                            recipients: true,
                            users: true,
                            levels: true,
                          });
                        }
                      });
                    }}
                    disabled={saving || !formik.isValid}
                    style={{
                      backgroundColor: "#fff",
                      borderColor: "#dc3545",
                      color: "#dc3545",
                    }}
                  >
                    {t("news:modalNotifications.schedule")}
                  </Button>
                  <Button type="submit" disabled={saving}>
                    {saving ? (
                      <TextLoading
                        text={t("global:buttons.sending")}
                        variant="light"
                      />
                    ) : (
                      t("news:modalNotifications.send")
                    )}
                  </Button>
                </div>
              </Modal.Footer>
            </Form>
          )}
        </Formik>
      </Modal>

      {showScheduleModal && (
        <Modal show={showScheduleModal}>
          <Modal.Header>
            <Modal.Title>{t("news:modalSchedule.title")}</Modal.Title>
          </Modal.Header>
          <Formik
            context={showScheduleModal}
            initialValues={notificationData}
            validationSchema={validationScheduleSchema}
            validateOnChange={true}
            validateOnBlur={true}
            onSubmit={async (values) => {
              setSaving(true);
              createNotification(values);
            }}
          >
            {(formik) => (
              <Form>
                <Modal.Body>
                  <Row>
                    <Col md={6}>
                      <DatePicker
                        label={t("news:modalSchedule.date")}
                        placeholderText={
                          language == "spanish" ? "DD/MM/YYYY" : "MM/DD/YYYY"
                        }
                        name="date"
                        minDate={new Date()}
                        dropdownMode="select"
                        dateFormat={
                          language == "spanish" ? "dd/MM/yyyy" : "MM/dd/yyyy"
                        }
                        {...Locallanguage}
                        isClearable
                        onChange={(date) => {
                          formik.setFieldValue("date", date ? date : "");
                          if (!date) {
                            formik.setFieldValue("time", "");
                          }
                        }}
                      />
                    </Col>
                    <Col md={6}>
                      <DatePicker
                        label={t("news:modalSchedule.time")}
                        placeholderText={"HH:MM AM/PM"}
                        name="time"
                        timeIntervals={15}
                        showTimeSelect
                        showTimeSelectOnly
                        minTime={getMinTime(formik.values.date)}
                        maxTime={new Date().setHours(23, 59, 59, 999)}
                        timeCaption={t("news:modalSchedule.time")}
                        dateFormat="hh:mm aa"
                        timeFormat="hh:mm aa"
                        {...Locallanguage}
                        isClearable
                        onChange={(time) => {
                          formik.setFieldValue("time", time ? time : "");
                        }}
                        disabled={
                          !formik.values.date || formik.values.date === ""
                        }
                      />
                    </Col>
                  </Row>
                  {error && (
                    <Row className="mt-3">
                      <Col md={12}>
                        <Alert
                          variant="warning"
                          style={{ wordBreak: "break-word" }}
                        >
                          {error}
                        </Alert>
                      </Col>
                    </Row>
                  )}
                </Modal.Body>
                <Modal.Footer style={{ justifyContent: "space-between" }}>
                  <Button
                    variant="outline-secondary"
                    onClick={() => props.setShowModalSendNotification(false)}
                    className="float-start"
                    disabled={saving}
                  >
                    {t("global:buttons.cancel")}
                  </Button>
                  <div className="float-end">
                    <Button
                      variant="outline-secondary"
                      onClick={() => {
                        setNotificationData(formik.values);
                        setShowScheduleModal(false);
                        setShowModal(true);
                      }}
                      disabled={saving}
                    >
                      {t("news:modalNotifications.back")}
                    </Button>
                    <Button variant="primary" type="submit" disabled={saving}>
                      {saving ? (
                        <TextLoading
                          text={t("global:buttons.sending")}
                          variant="light"
                        />
                      ) : (
                        t("news:modalNotifications.send")
                      )}
                    </Button>
                  </div>
                </Modal.Footer>
              </Form>
            )}
          </Formik>
        </Modal>
      )}
    </>
  );
}

ModalSendNotification.propTypes = {
  showModalSendNotification: PropTypes.bool, //Required
  setShowModalSendNotification: PropTypes.func, //Required
  news: PropTypes.number.isRequired, //Required
  notificationCreated: PropTypes.func, //Optional callback when notification is created
};
